export default __webpack_public_path__ + "static/media/banner1.dfb63d61.jpg";